import React, { createContext, useContext, useState, useEffect } from 'react';

const CTISSchemaContext = createContext();

export const CTISSchemaProvider = ({ children }) => {
  const [screenIndex, setScreenIndex] = useState(null);
  const [activeTemplate, setActiveTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/data/EMA_standards/_screen_index.json')
      .then(res => res.json())
      .then(data => {
        setScreenIndex(data);
        setLoading(false);
      })
      .catch(err => console.error("CTISSchemaProvider: Index Load Error", err));
  }, []);

  const loadTemplate = async (templateId) => {
    if (!screenIndex) return null;
    const entry = screenIndex.screens.find(s => s.screen_id === templateId);
    if (!entry) return null;

    try {
      const response = await fetch(`/data/EMA_standards/templates/${entry.template_file}`);
      const data = await response.json();
      setActiveTemplate(data);
      return data;
    } catch (err) {
      console.error("CTISSchemaProvider: Template Load Error", err);
      return null;
    }
  };

  return (
    <CTISSchemaContext.Provider value={{ screenIndex, activeTemplate, loadTemplate, loading }}>
      {children}
    </CTISSchemaContext.Provider>
  );
};

export const useCTISSchema = () => useContext(CTISSchemaContext);